import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

// Logo: public/asimlogo.png (Vite'da public/ kök olarak sunulur → /asimlogo.png)
const LOGO_SRC = '/asimlogo.png';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Anasayfa', path: '/' },
    { name: 'Projeler', path: '/projeler' },
    { name: 'STUDIO ASIM METE', path: '/studyo-asim-mete' },
    { name: 'GRAVITAS LIBERA', path: '/gravitas-libera' },
    { name: 'İletişim', path: '/iletisim' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0e0c0a]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src={LOGO_SRC} 
              alt="Studio Asım Mete Logo" 
              className="h-10 md:h-12 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-xs tracking-widest transition-colors duration-300 whitespace-nowrap cursor-pointer font-sans uppercase ${
                  location.pathname === link.path
                    ? 'text-white font-normal'
                    : 'text-white hover:text-white font-light'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-white w-8 h-8 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-[#0e0c0a]/98 backdrop-blur-md py-6 px-6 space-y-4 border-t border-[#2a2018]">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block text-sm tracking-widest transition-colors duration-300 cursor-pointer font-sans uppercase ${
                  location.pathname === link.path
                    ? 'text-white font-normal'
                    : 'text-white hover:text-white font-light'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}